import React, { Component } from "react";
import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import ElementWrapper from "./../ElementWrapper";
import { connect } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import IconPicker from "../IconPicker";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MaterialMenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FilterDiscussions from "../filter/FilterDiscussions";
import FilterSearches from "../filter/FilterSearches";
import FilterEntries from "../filter/FilterEntries";
import FilterDocuments from "../filter/FilterDocuments";
import FilterReports from "../filter/FilterReports";
import FilterRequiredReading from "../filter/FilterRequiredReading";
import FilterSearchHistory from "../filter/FilterSearchHistory";
import FilterRework from "../filter/FilterRework";
import FilterWrapper from "../filter/FilterWrapper";
import { Droppable, Draggable } from "react-beautiful-dnd";
import CreateMessage from "../messages/CreateMessage";
import AreYouSureDialog from "./../dialog/AreYouSureDialog";
import FilterLists from "../filter/FilterLists.js";
import FilterNotifications from "../filter/FilterNotifications.js";
import FilterExpertQuestion from "../filter/FilterExpertQuestion.js";
import RequiredReadingDialog from "./../required-reading/RequiredReadingDialog";
import SuggestGlobalAttachmentDialog from "./../dialog/SuggestGlobalAttachmentDialog";
import CreatePortletDialog from "./../dialog/CreatePortletDialog";
import axios from "../../AxiosClient";
import PubSub from "pubsub-js";
import {
  PORTLET_LAYOUT_ADD,
  MENU_PORTLET_DELETE,
  MENU_PORTLET_UPDATE,
} from "../../utils/Topics";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import "material-icons/iconfont/material-icons.css";
import {
  Role,
  currentUserHasRoleId,
  currentUserHasRole,
  currentUserIsOperator,
} from "../../utils/RoleUtils";
import { object } from "arc-hash";
import { deleteCustomField } from "./../../redux/actions/customFieldsActions";
import DocumentFilterDialog from "../document/DocumentFilterDialog";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  button: {
    display: "block",
    width: "100%",
  },
  leaf: {
    letterSpacing: 0,
    justifyContent: "flex-start",
    textTransform: "none",
    width: "100%",
    fontWeight: theme.typography.fontWeightRegular,
    textTransform: "none",
  },
  dropdownButton: {
    width: "100%",
    justifyContent: "flex-start",
    textTransform: "none",
  },
  topLevel: {
    width: "100%",
    justifyContent: "flex-start",
    textTransform: "none",
  },
  popper: {
    zIndex: 1300,
    maxWidth: "30%",
    "& $arrow": {
      left: 0,
      top: "41%",
      marginLeft: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${
          theme.palette.common.white
        } transparent transparent`,
      },
    },
  },
  popperPaper: {
    height: "50%",
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  addIcon: {
    margin: "0px 24px 0px auto",
    padding: 0,
  },
  iconSelect: {
    marginRight: 30,
  },
  dragHandle: {
    fontSize: "1.5rem",
    marginLeft: -15,
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  appBar: {
    position: "relative",
  },
});

const elementMappings = {
  CreateMessage,
  RequiredReadingDialog,
  SuggestGlobalAttachmentDialog,
  CreatePortletDialog,
};
const filterMappings = {
  FilterRework,
  FilterSearchHistory,
  FilterLists,
  FilterDocuments,
  FilterReports,
  FilterDiscussions,
  FilterEntries,
  FilterSearches,
  FilterRequiredReading,
  FilterNotifications,
  FilterExpertQuestion,
};
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class MenuItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      childrenOpen: this.props.onlySection,
      popperOpen: false,
      editPopperOpen: false,
      iconPickerOpen: false,
      itemTitle: props.item.title,
      itemIcon: props.item.icon,
      instance: new Date().getTime().toString(),
      filters: null,
      dialogType: null,
      deleteConfirmOpen: false,
      showFilters: false,
      filterPopperOpen: false,
      filterInstance: "",
      showReset: true,
      openSelectDocument: false,
      selectedDocument: null,
      item: this.props.item,
    };
    this.addToLayout = this.addToLayout.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    let filters = this.state.filters;
    // let filters = this.state.item.hasOwnProperty("parameters")
    // ? typeof this.state.item.parameters === "object"
    //   ? this.state.item.parameters
    //   : JSON.parse(this.state.item.parameters)
    // : {}

    // let prevFilters = prevProps.item.hasOwnProperty("parameters")
    // ? typeof prevProps.item.parameters === "object"
    //   ? prevProps.item.parameters
    //   : JSON.parse(prevProps.item.parameters)
    // : {}

    // if (!areObjectsEqual(filters,prevFilters)) {
    //   let filters2Compare = {...this.state.filters}
    //   delete filters2Compare.page
    //   delete filters2Compare.pageSize
    //   if (!areObjectsEqual(filters,filters2Compare)) {
    //     this.setState({
    //       filters: filters
    //     })
    //   }
    // }
  }
  updatePortlet = (item) => {
    this.setState({ item });
  };
  getEditPopover = () => {
    let WrappedElement;
    let listItemTitleColumn = null;
    if (
      this.state.item.objectClass != "" &&
      this.state.item.children.length > 0
    ) {
      let filterType = null;
      // if (
      //   this.state.item.objectClass ===
      //   "com.kpsol.api.apicommon.search.SearcherInterface"
      // ) {
      //   filterType = "FilterSearches";
      // } else
      if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.document.DocumentInterface"
      ) {
        filterType = "FilterDocuments";
        listItemTitleColumn = {
          name: "title",
          message: "global_document_title",
        };
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.document.ReportInterface"
      ) {
        filterType = "FilterReports";
        listItemTitleColumn = {
          name: "title",
          message: "global_document_title",
        };
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.discussions.EntryInterface"
      ) {
        filterType = "FilterEntries";
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface"
      ) {
        filterType = "FilterDiscussions";
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.stats.MyStatsInterface"
      ) {
        filterType = <div />;
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.history.SearchHistoryInterface"
      ) {
        filterType = "FilterSearchHistory";
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.rework.ReworkInterface"
      ) {
        filterType = "FilterRework";
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.content.KnowledgeItemInterface"
      ) {
        filterType = "FilterKnowledgeItem";
        listItemTitleColumn = {
          name: "documentTitle",
          message: "global_document_title",
        };
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface"
      ) {
        filterType = "FilterRequiredReading";
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.hottopic.HotTopicInterface"
      ) {
        filterType = "FilterNotifications";
      } else if (
        this.state.item.objectClass ===
        "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface"
      ) {
        filterType = "FilterExpertQuestion";
      }
      WrappedElement = filterMappings[filterType];
    }

    return (
      <Popover
        open={this.state.editPopperOpen}
        anchorEl={this.editAnchorEl}
        onClose={this.closeEditPopper}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <DialogTitle>
          <Trans i18nKey="edit_menu_item_title" />
        </DialogTitle>
        <DialogContent
          style={{ maxWidth: 650, maxHeight: 350, overflowY: "auto" }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
              <FormControl className={this.props.classes.iconSelect}>
                <InputLabel htmlFor="icon">Icon</InputLabel>
                <Select
                  open={false}
                  value="icon"
                  onOpen={this.openIconPicker}
                  inputProps={{
                    name: "icon",
                    id: "icon",
                  }}
                >
                  <MaterialMenuItem value="icon">
                    <span className="material-icons">
                      {this.state.itemIcon}
                    </span>
                  </MaterialMenuItem>
                </Select>
              </FormControl>
              <IconPicker
                open={this.state.iconPickerOpen}
                onPick={this.changeItemIcon}
                handleClose={this.closeIconPicker}
              />
            </div>
            <KpsTextField
              fullWidth
              required
              label={this.props.t("link_title")}
              value={this.state.itemTitle}
              onChange={this.handleItemTitleChange}
            />
          </div>
          {/* {filter} */}
          {WrappedElement && (
            <WrappedElement
              {...this.props}
              listItemTitleColumn={listItemTitleColumn}
              filter={this.state.filters}
              onFilterChange={this.onFilterChange}
              isFilterBar={false}
              showReset={false}
              resetToDefaultFilters={this.props.resetToDefaultFilters}
              menuDialog
            />
          )}
          <AreYouSureDialog
            open={this.state.deleteConfirmOpen}
            onClose={this.closeDeleteConfirm}
            onSubmit={this.deleteMenuPortlet}
          >
            <Trans i18nKey="admin_delete_menu_portlet_confirm">
              Are you sure you want to delete this portlet from the menu for all
              users?
            </Trans>
          </AreYouSureDialog>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.openDeleteConfirm}
            className={this.props.classes.deleteButton}
          >
            <Trans i18nKey="global_delete" />
          </Button>
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              flex: 1,
              flexDirection: "row",
            }}
          >
            <div style={{ flexGrow: 1, display: "flex" }} />
            <Button onClick={this.cancelEditPopper}>
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button onClick={this.saveEdits}>
              <Trans i18nKey="global_save" />
            </Button>
          </div>
        </DialogActions>
      </Popover>
    );
  };

  getDialogElement = () => {
    if (this.state.type) {
      let DialogType = elementMappings[this.state.type];
      let props = {};
      if (this.state.type === "CreatePortletDialog") {
        props.addPortlet = true;
      }
      return (
        <DialogType
          onClose={this.onDialogClose}
          open={true}
          fromMenu
          handleSubmit={this.addPortlet}
          {...props}
        />
      );
    } else {
      return null;
    }
  };

  onDialogClose = () => {
    this.setState({ type: null });
  };

  openDeleteConfirm = () => {
    this.setState({ deleteConfirmOpen: true });
  };

  closeDeleteConfirm = () => {
    this.setState({ deleteConfirmOpen: false });
  };

  userCanView = (item) => {
    if (
      this.props.isMobile &&
      (item.id === 1125 ||
        item.id === 1135 ||
        item.id === 1131 ||
        item.id === 1003 ||
        item.id === 1045 ||
        item.id === 1143 ||
        item.id === 1120 ||
        item.id === 1039 ||
        item.id === 1136 ||
        item.id === 1121 ||
        item.id === 1139 ||
        item.id === 1027 ||
        item.id === 1126 ||
        item.id === 1048 ||
        item.id === 1028)
    )
      return false;

    if (item.id === 1001 || item.id === 1002 || item.id === 1003) {
      return this.anyChildVisible(item.children);
    }
    if (
      item.id === 1021 &&
      this.props.portalLayout.layoutType === "team" &&
      this.props.portalLayout.creator !== this.props.currentUser.userId &&
      !currentUserHasRole(Role.TEAM_LEADER)
    ) {
      return false;
    }
    let childVisible = true;
    if (item.children.length > 0) {
      childVisible = this.anyChildVisible(item.children);
    }

    for (const roleId of item.requiredRoles) {
      if (currentUserHasRoleId(roleId) && childVisible) {
        return true;
      }
    }
    return false;
  };

  anyChildVisible = (children) => {
    for (const child of children) {
      if (this.userCanView(child)) {
        if (this.props.addIfViewable) {
          this.props.addIfViewable(true);
        }
        return true;
      }
      if (child.children.length > 0) {
        if (this.anyChildVisible(child.children)) {
          if (this.props.addIfViewable) {
            this.props.addIfViewable(true);
          }
          return true;
        }
      }
    }
    if (this.props.addIfViewable) {
      this.props.addIfViewable(false);
    }
    return false;
  };

  render() {
    const { classes } = this.props;

    const style = {
      paddingLeft: 8 * (3 + 2 * this.props.depth),
    };

    if (!this.userCanView(this.state.item)) {
      return null;
    }

    if (this.state.item.isHidden) {
      return null;
    }

    if (this.state.item.children.length === 0) {
      let thePortlet = { ...this.state.item };
      thePortlet.originalMenuPortlet = {};
      thePortlet.originalMenuPortlet.parameters = this.state.item.parameters;
      let params = this.state.filters
        ? this.state.filters
        : this.state.item.parameters
          ? typeof this.state.item.parameters === "object"
            ? this.state.item.parameters
            : JSON.parse(this.state.item.parameters)
          : {};

      thePortlet.parameters = params;
      return (
        <>
          <Draggable
            draggableId={this.state.item.id.toString()}
            index={this.props.index}
            type={
              this.props.depth === 0 ? "top" : `child-${this.props.parentId}`
            }
            isDragDisabled={
              !this.props.editMode &&
              (this.props.currentUser.userPermits.roles.administrator ||
                (this.state.item.isUser === 1 &&
                  this.state.item.userid === this.props.currentUser.userId))
            }
          >
            {/* ` */}
            {(dragProvided, dragSnapshot) => (
              <div
                isDragging={dragSnapshot.isDragging}
                ref={dragProvided.innerRef}
                {...dragProvided.draggableProps}
              >
                <ListItem disableGutters style={style} dense>
                  <span style={{ display: "flex", width: "100%" }}>
                    {this.props.editMode &&
                      ((this.state.item.isUser === 1 &&
                        this.state.item.userid ===
                          this.props.currentUser.userId) ||
                        this.props.currentUser.userPermits.roles
                          .administrator) && (
                        <span
                          className={`mdi mdi-drag-vertical ${
                            classes.dragHandle
                          }`}
                          {...dragProvided.dragHandleProps}
                        />
                      )}
                    {/* ` */}
                    <Button
                      disableTouchRipple
                      className={
                        this.props.topLevel ? classes.topLevel : classes.leaf
                      }
                      onClick={this.onLeafClick}
                    >
                      <span
                        className="material-icons"
                        style={{ marginRight: 10 }}
                      >
                        {this.state.itemIcon}
                      </span>
                      {this.state.item.isDefault === 1 ? (
                        <Trans i18nKey={this.state.itemTitle}>
                          {this.state.itemTitle}
                        </Trans>
                      ) : (
                        <div>{this.state.itemTitle}</div>
                      )}
                      {(this.state.item.elementType === "CardList" ||
                        this.state.item.elementType === "CardStats" ||
                        this.state.item.elementType === "CardDocument") &&
                        !this.props.editMode && (
                          <IconButton
                            id={"add-to-layout-" + this.state.item.id}
                            aria-label="Add to layout"
                            ref={(ref) => (this.anchorEl = ref)}
                            onClick={
                              this.state.item.elementType === "CardDocument"
                                ? this.documentDialog
                                : this.addToLayout
                            }
                            className={classes.addIcon}
                            disabled={
                              (this.props.portalLayout.layoutType === "team" &&
                                !currentUserHasRole(Role.TEAM_LEADER)
                                ) ||
                              this.props.currentUser.userType === "limited"
                              ||
                              (this.props.portalLayout.layoutType === "team" &&
                              !this.props.teamLayoutEditMode)
                            }
                          >
                            <AddIcon />
                          </IconButton>
                        )}
                      {this.props.editMode &&
                        ((this.state.item.isUser === 1 &&
                          this.state.item.userid ===
                            this.props.currentUser.userId) ||
                          this.props.currentUser.userPermits.roles
                            .administrator) && (
                          <IconButton
                            aria-label={"edit-" + this.state.itemTitle}
                            className={classes.addIcon}
                            ref={(ref) => {
                              this.editAnchorEl = ref;
                              this.anchorEl = ref;
                            }}
                            onClick={this.editItem}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                    </Button>
                  </span>
                  {(this.state.item.elementType === "CardList" ||
                    this.state.item.elementType === "CardStats") && (
                    <Dialog
                      fullScreen
                      open={this.state.popperOpen}
                      onClose={this.closePopper}
                    >
                      <AppBar className={classes.appBar}>
                        <Toolbar>
                          <IconButton
                            edge="start"
                            color="inherit"
                            onClick={this.closePopper}
                            aria-label="close"
                          >
                            <CloseIcon />
                          </IconButton>
                          <Typography type="title">
                            <Trans i18nKey={this.state.item.title} />
                          </Typography>
                        </Toolbar>
                      </AppBar>
                      <ElementWrapper
                        fullscreen
                        icon={this.state.icon}
                        title={this.state.title}
                        parameters={params}
                        portlet={thePortlet}
                        menuDialog={true}
                        toggleFilters={this.toggleFilters}
                        updateFilters={this.updateFilters}
                        updatePortlet={this.updatePortlet}
                      />
                    </Dialog>
                  )}
                  {this.getDialogElement()}
                  {this.getEditPopover()}
                </ListItem>
              </div>
            )}
          </Draggable>
          <DocumentFilterDialog
            open={this.state.openSelectDocument}
            handleClose={() => this.setState({ openSelectDocument: false })}
            onSubmit={this.documentSelect}
            singleSelect
          />
        </>
      );
    } else {
      let newDepth = this.props.depth + 1;
      return (
        <Draggable
          draggableId={this.state.item.id.toString()}
          index={this.props.index}
          type={this.props.depth === 0 ? "top" : `child-${this.props.parentId}`}
          isDragDisabled={!this.props.editMode}
        >
          {/* ` */}
          {(dragProvided, dragSnapshot) => (
            <div
              isDragging={dragSnapshot.isDragging}
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
            >
              <ListItem
                disableGutters
                classes={{ root: classes.button }}
                style={style}
                dense={this.props.depth > 0}
              >
                <span style={{ display: "flex", width: "100%" }}>
                  {this.props.editMode &&
                    (this.props.currentUser.userPermits.roles.administrator ||
                      (this.state.item.isUser === 1 &&
                        this.state.item.userid ===
                          this.props.currentUser.userId)) && (
                      <span
                        className={`mdi mdi-drag-vertical ${
                          classes.dragHandle
                        }`}
                        {...dragProvided.dragHandleProps}
                      />
                    )}
                  <Button
                    disableTouchRipple
                    onClick={this.onExpandableClick}
                    className={classes.dropdownButton}
                  >
                    <span
                      className="material-icons"
                      style={{ marginRight: 10 }}
                    >
                      {this.state.itemIcon}
                    </span>
                    {this.state.item.isDefault === 1 ? (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "left",
                        }}
                      >
                        {" "}
                        <Trans i18nKey={this.state.itemTitle}>
                          {this.state.itemTitle}
                        </Trans>
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "left",
                        }}
                      >
                        {this.state.itemTitle}
                      </div>
                    )}
                    <span
                      className="material-icons"
                      style={{
                        marginLeft: 10,
                        margin: this.props.editMode
                          ? "0px 8px 0px auto"
                          : "0px 24px 0px auto",
                        textAlign: "end",
                      }}
                    >
                      {this.state.childrenOpen ? (
                        <>expand_less</>
                      ) : (
                        <>expand_more</>
                      )}
                    </span>
                    {this.props.editMode &&
                      (this.props.currentUser.userPermits.roles.administrator ||
                        (this.state.item.isUser === 1 &&
                          this.state.item.userid ===
                            this.props.currentUser.userId)) && (
                        <IconButton
                          id="test"
                          className={classes.addIcon}
                          ref={(ref) => (this.editAnchorEl = ref)}
                          onClick={this.editItem}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                  </Button>
                </span>
                {this.getEditPopover()}
                <Collapse in={this.state.childrenOpen} unmountOnExit={true}>
                  <Droppable
                    droppableId={this.state.item.id}
                    type={`child-${this.state.item.id}`}
                  >
                    {(dropProvided, dropSnapshot) => (
                      <div
                        ref={dropProvided.innerRef}
                        {...dropProvided.droppableProps}
                      >
                        {this.state.item.children
                          .sort((a, b) => {
                            if (a.order === b.order) {
                              return a.title < b.title ? -1 : 1
                            } else {
                              return a.order < b.order ? -1 : 1
                            }
                          })
                          .map((ele, idx) => {
                            return (
                              <ChildMenuItem
                                key={ele.id}
                                item={ele}
                                depth={newDepth}
                                editMode={this.props.editMode}
                                parentId={this.state.item.id}
                                onClose={this.props.onClose}
                                index={idx}
                              />
                            );
                          })}
                        {dropProvided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </Collapse>
                {this.getDialogElement()}
              </ListItem>
            </div>
          )}
        </Draggable>
      );
    }
  }
  documentSelect = (documents, e) => {
    this.setState(
      {
        selectedDocument: documents[0],
        openSelectDocument: false,
      },
      () => this.addToLayout(e)
    );
  };
  documentDialog = () => {
    this.setState({ openSelectDocument: true });
  };
  getData = () => {
    let parameters = this.props.portlet.parameters
      ? typeof this.props.portlet.parameters !== "object"
        ? JSON.parse(this.props.portlet.parameters)
        : this.props.portlet.parameters
      : {};
    // parameters.size = this.state.pageSize;
    // parameters.page = this.state.startIndex;
    let url = "";
    switch (this.props.messageType) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
        url = "/document/";
        break;
      case "com.kpsol.api.apicommon.document.ReportInterface":
        url = "/document/reports";
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
        url = "/searchhistory/filter";
        break;
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        url = "/knowledgeitem/";
        break;
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        url = "/discussion/";
        break;
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        url = "/requiredreading/alerted";
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        url = "/entry/";
        break;
      case "com.kpsol.api.apicommon.list.ListUserListsInterface":
        url = "/userlist/";
        break;
      case "com.kpsol.api.apicommon.hottopic.HotTopicInterface":
        url = "/hottopic/user/active";
        break;
      case "com.kpsol.api.apicommon.list.UserListInterface":
        url = `/userlist/${parameters.listID}/items`;
        break;
      default:
        break;
    }
    axios
      .get(url, {
        params: parameters,
      })
      .then((res) => {
        if (res.data.numberOfElements > 9) {
          this.setState({ startIndex: res.data.number + 1 });
        }
        if (res.data.number === 0) {
          this.setState({ data: res.data.content });
        } else {
          this.setState({ data: [...this.state.data, ...res.data.content] });
        }
      });
  };

  cancelEditPopper = () => {
    this.setState({
      itemTitle: this.state.item.title,
      itemIcon: this.state.item.icon,
      filters: JSON.parse(this.state.item.parameters),
    });
    this.closeEditPopper();
  };

  deleteMenuPortlet = () => {
    axios.delete(`/menuportlet/${this.state.item.id}`).then((res) => {
      this.closeDeleteConfirm();
      this.closeEditPopper();
      PubSub.publish(MENU_PORTLET_DELETE);
    });
  };

  saveEdits = () => {
    this.closeEditPopper();
    let portlet = { ...this.state.item };
    portlet.icon = this.state.itemIcon;
    portlet.title = this.state.itemTitle;
    axios
      .patch(`/menuportlet/${portlet.id}`, {
        ...portlet,
      })
      .then((res) => {
        PubSub.publish(MENU_PORTLET_UPDATE);
      });
  };

  handleItemTitleChange = (e) => {
    this.setState({ itemTitle: e.target.value });
  };

  openIconPicker = () => {
    this.setState({ iconPickerOpen: true });
  };

  changeItemIcon = (e) => {
    this.setState({ itemIcon: e });
  };

  closeIconPicker = () => {
    this.setState({ iconPickerOpen: false });
  };

  editItem = (e) => {
    e.stopPropagation();
    this.setState({ editPopperOpen: true });
  };

  closeEditPopper = () => {
    this.setState({ editPopperOpen: false });
  };

  closeFilterPopper = () => {
    this.setState({ filterPopperOpen: !this.state.filterPopperOpen });
  };

  onExpandableClick = () => {
    this.setState((prev) => ({ childrenOpen: !prev.childrenOpen }));
  };

  onLeafClick = () => {
    switch (this.state.item.elementType) {
      case "CardStats":
      case "CardList":
        this.onListClick();
        break;
      case "MenuLink":
        this.onLinkClick();
        break;
      case "MenuLinkDialog":
        this.onDialogClick();
        break;
      default:
        break;
    }
  };

  onLinkClick = () => {
    this.props.history.push(JSON.parse(this.state.item.parameters).route);
    this.props.onClose();
  };

  addPortlet = (portlet) => {
    PubSub.publish(PORTLET_LAYOUT_ADD, {
      layoutId: this.props.portalLayout.id,
      portletId: portlet.id,
    });
    this.onDialogClose();
  };

  addToLayout = (e) => {
    e.stopPropagation();
    let portlet = Object.assign({}, this.state.item);
    portlet.isportlet = true;
    portlet.fullscreen = false;
    portlet.menuPortletId = this.state.item.id;
    portlet.id = null;
    portlet.instance = new Date().getTime();
    if (typeof this.state.item.parameters === "object") {
      portlet.parameters = JSON.stringify(this.state.item.parameters);
    }
    if (typeof this.state.item.parameters === "object") {
      portlet.parameters = JSON.stringify(this.state.item.parameters);
    }
    if (this.state.item.elementType === "CardDocument") {
      portlet.parameters = JSON.stringify({
        documentId: this.state.selectedDocument.documentID,
      });
      portlet.title = this.state.selectedDocument.userTitle;
    }
    axios
      .post(`/portalLayout/${this.props.portalLayout.id}/portlet/`, {
        ...portlet,
      })
      .then((res) => {
        PubSub.publish(PORTLET_LAYOUT_ADD, {
          layoutId: this.props.portalLayout.id,
          portletId: res.data.id,
        });
      });

    this.setState({ openedAddListToLayout: !this.state.openedAddListToLayout });
  };

  onListClick = () => {
    this.setState((prev) => ({ popperOpen: !prev.popperOpen }));
  };

  onDialogClick = () => {
    let params = JSON.parse(this.state.item.parameters);
    this.setState({ type: params.type });
  };

  closePopper = () => {
    this.setState({ popperOpen: false });
  };

  toggleFilters = (
    anchorEl,
    filterElement,
    filters,
    onFilterChange,
    filterTitle,
    showReset,
    resetToDefaultFilters,
    instance
  ) => {
    var filter = this.state.showFilters;
    anchorEl === this.state.filterAnchorEl && this.state.showFilters === true
      ? (filter = false)
      : (filter = true);

    this.setState(
      {
        filters: filters,
        showFilters: filter,
        filterAnchorEl: anchorEl,
        filterElement: filterElement,
        onFilterChange: onFilterChange,
        filterTitle: filterTitle,
        showReset: showReset,
        resetToDefaultFilters: resetToDefaultFilters,
        filterInstance: instance,
      },
      () => {}
    );
  };
  updateFilters = (newfilters, showReset, instance) => {
    if (
      this.state.filterInstance === instance ||
      this.state.filterInstance === ""
    ) {
      this.setState(
        {
          filters: newfilters,
          showReset: showReset,
        },
        () => {
          // alert(this.state.filters.taxonomy)
        }
      );
    }
  };

  closeFilters = () => {
    this.setState((prev) => ({ showFilters: false }));
  };
}
const mapStateToProps = (state) => ({
  edit: state.layout.edit,
  portalLayout: state.layout.currentLayout,
  currentUser: state.user.currentUser,
  isMobile: state.screen.isMobile,
  teamLayoutEditMode: state.layout.teamLayoutEditMode,
});
const ChildMenuItem = connect(
  mapStateToProps,
  null
)(withRouter(withStyles(styles)(withTranslation()(MenuItem))));
export default ChildMenuItem;
